<template>
  <div v-if="$route.query.mode!=='design'" ref="viewer" style="position: absolute; left: 0; right: 0; top: 0; bottom: 0" data-bind="dxReportViewer: $data"></div>
  <div v-else ref="viewer" class="report-viewer" style="position: absolute; left: 0; right: 0; top: 0; bottom: 0" data-bind="dxReportDesigner: $data" />
</template>

<script>
import ko from "knockout";
import { ajaxSetup } from '@devexpress/analytics-core/analytics-utils'
import 'devexpress-reporting/dx-webdocumentviewer'
import 'devexpress-reporting/dx-reportdesigner'
import '@devexpress/analytics-core/dist/css/dx-analytics.common.css'
import '@devexpress/analytics-core/dist/css/dx-analytics.light.css'
import '@devexpress/analytics-core/dist/css/dx-querybuilder.css'
import 'devexpress-reporting/dist/css/dx-webdocumentviewer.css'
import 'devexpress-reporting/dist/css/dx-reportdesigner.css'

export default {
  name: "WebDocumentViewer",
  mounted() {
    ko.cleanNode(this.$refs.viewer)
    const reportName = this.$route.query.reportName
    //window.console.log(this.$route.query.reportApi)
    //window.console.log(this.$route.query.token)
    const viewerOptions = {
      reportUrl: ko.observable(reportName), // The URL of a report.
      requestOptions: {
        host: this.$route.query.reportHost,
        invokeAction: "DXXRDV",
        getDesignerModelAction: 'api/ReportDesignerSetup/GetReportDesignerModel'
      }
    };
    ajaxSetup.ajaxSettings = {
      // xhrFields: {
      //   withCredentials: true
      // },
      headers: {
        // 'X-XSRF-TOKEN': this.$route.query.csrf,
        Authorization: this.$route.query.token,
        Accept: 'application/json',
        contentType: 'application/json',
        NBOData: this.$route.query.reportApi
      }
    }
    ko.applyBindings(viewerOptions, this.$refs.viewer);
  },
  beforeDestroy() {
    ko.cleanNode(this.$refs.viewer);
  }
};
</script>